import { Link } from "react-router-dom";
import { getHotComics } from "@/mocks/comics";

export default function HotRanking() {
  const hotComics = getHotComics();

  return (
    <section className="py-16 md:py-20 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-1 h-5 rounded-full bg-accent-500" />
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
              热门排行
            </h2>
            <span className="text-xs text-accent-500 font-medium px-2 py-0.5 rounded bg-accent-500/10 whitespace-nowrap">
              TOP 6
            </span>
          </div>
          <p className="text-foreground-500 text-sm">
            根据阅读量排名的热门韩漫，大家都在看
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {hotComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-200/50 border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 no-underline"
            >
              <div className="flex-shrink-0 relative">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-lg text-lg font-heading font-bold ${
                    index === 0
                      ? "bg-accent-500 text-background-50"
                      : index === 1
                        ? "bg-primary-500/80 text-background-50"
                        : index === 2
                          ? "bg-secondary-500/80 text-background-50"
                          : "bg-background-200 text-foreground-400"
                  }`}
                >
                  {index + 1}
                </div>
              </div>
              <div className="w-14 h-20 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-100 truncate group-hover:text-primary-500 transition-colors duration-200">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 truncate">
                  {comic.author}
                </p>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-xs text-accent-500">
                    <i className="ri-star-fill text-[10px] mr-0.5"></i>
                    {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">
                    <i className="ri-eye-line text-[10px] mr-0.5"></i>
                    {comic.views >= 10000
                      ? `${(comic.views / 10000).toFixed(0)}万`
                      : comic.views}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 text-foreground-500 group-hover:text-primary-500 transition-colors duration-200">
                <i className="ri-arrow-right-s-line text-xl"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}